export enum NotificationSubCategoryStatusEnum {
  ACTIVE = "a",
  INACTIVE = "i",
}

export type NotificationSubCategoryStatusTypes =
  `${NotificationSubCategoryStatusEnum}`;

export enum NotificationSubCategoryGroupKeyEnum {
  // --- Campaign OWNER: General --- //
  CAMPAIGN_STATUS = "campaign_status", // When Campaign Status Changes
  // --- Campaign OWNER: Affiliate --- //
  CAMPAIGN_AFF = "campaign_aff", // Campaign Affiliate Notification
  // --- Affiliate in Campaign --- //
  AFF_PROPOSAL = "aff_proposal", // The Affiliate Receive Proposal from Campaign
  // --- Financial --- //
  FINANCIAL = "financial",
  // --- Commission --- //
  COMMISSION = "commission",
}

export type NotificationSubCategoryGroupKeyTypes =
  `${NotificationSubCategoryGroupKeyEnum}`;

export enum NotificationSubCategoryIds {
  // --- Campaign OWNER: General --- //
  CAMPAIGN_STATUS_INACTIVE = 1, // When Owner turn off your own Campaign
  // --- Campaign OWNER: Affiliate --- //
  CAMPAIGN_AFF_REQUEST = 20, // receive aff request
  CAMPAIGN_AFF_ACCEPT = 21, // aff accept proposal
  CAMPAIGN_AFF_REJECT = 22, // aff reject proposal
  CAMPAIGN_AFF_BLOCK = 23, // aff block owner request for this Campaign
  // --- Affiliate in Campaign --- //
  AFFILIATE_PROPOSAL_REQUEST = 40, // receive proposal from Campaign Owner
  AFFILIATE_PROPOSAL_ACCEPT = 41, // proposal accepted by Campaign Owner
  AFFILIATE_PROPOSAL_REJECT = 42, // proposal rejected by Campaign Owner
  AFFILIATE_PROPOSAL_BLOCK = 43, // proposal blocked by Campaign Owner
  // --- Financial --- //
  FINANCIAL_WITHDRAW_REQUEST = 60,
  FINANCIAL_WITHDRAW_APPROVED = 61,
  FINANCIAL_WITHDRAW_DENIED = 62,
  // --- Commission --- //
  COMMISSION_RECEIVED = 80,
}

export type NotificationSubCategoryIdTypes = NotificationSubCategoryIds;

export interface NotificationSubCategoryDTO {
  id: NotificationSubCategoryIdTypes;
  category: number;
  groupKey: NotificationSubCategoryGroupKeyTypes;
  title: string;
  description: string;
  status: NotificationSubCategoryStatusTypes;
  groupLabel: string;
  templateHtml: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface NotificationSubCategoryGroupsDTO {
  groupKey: NotificationSubCategoryGroupKeyTypes;
  groupLabel: string;
}

export interface NotificationSubCategoryGroupDTO {
  categoryId: number;
  categoryLabel: string;
  groups: NotificationSubCategoryGroupsDTO[];
}

export interface NotificationSubCategoryGroupKeyDTO {
  groupKey: NotificationSubCategoryGroupKeyTypes;
  text: string;
  description?: string;
}
